const user = {
  name: "Chirag Bhalotia",
  avatar: "img/ui/avatar.png",
};

export default user;
